import { useCallback, useMemo } from "react";
import { IBuildType, ITerm, ITermToBuilder } from "@evennt-tech/api-v2-core";
import { ConflictingTermByBuilder } from "view/apps/Organiser/pages/Show/Glossary/components/AssignTermPopupToBuildTypeModal/utils/types";

type Params = {
  termsByBuilder: Map<string, ITermToBuilder[]>;
  popupTerm: ITerm;
  termById: Record<string, ITerm>;
  builders: IBuildType[];
  selectedBuilderIds: string[];
};
export const useConflictingTermPopupBuildTypes = ({
  termsByBuilder,
  popupTerm,
  builders,
  termById,
  selectedBuilderIds,
}: Params) => {
  const checkConflictingBuilders = useCallback(
    (builderIds: string[]): ConflictingTermByBuilder | null => {
      const conflictingTermByBuilder = builderIds.reduce<
        Record<string, string>
      >((acc, curr) => {
        const currentBuilderTerms = termsByBuilder.get(curr);
        if (!currentBuilderTerms) {
          return acc;
        }
        const otherTtbWithPopupEnabled = currentBuilderTerms.find(
          (ttb) => ttb.shouldShowPopup && ttb.termId !== popupTerm.id
        );
        if (!otherTtbWithPopupEnabled) {
          return acc;
        }

        const otherTerm = termById[otherTtbWithPopupEnabled.termId];
        if (!otherTerm) {
          return acc;
        }
        const builder = builders.find((b) => b.id === curr);
        if (builder) {
          acc[builder.id] = otherTerm.id;
        }
        return acc;
      }, {});

      const keys = Object.keys(conflictingTermByBuilder);

      return keys.length ? conflictingTermByBuilder : null;
    },
    [builders, termsByBuilder, termById, popupTerm.id]
  );

  const conflictingTermByBuilder = useMemo(() => {
    return checkConflictingBuilders(selectedBuilderIds);
  }, [checkConflictingBuilders, selectedBuilderIds]);

  return { checkConflictingBuilders, conflictingTermByBuilder } as const;
};
